import React from 'react';
import { Meeting, MeetingMemberPreferences } from '../../services/meetingService';
import { preferencesCardSubtitle } from '../../data/workshopPreferencesSummary';
import WorkshopCollapsibleCard from './WorkshopCollapsibleCard';
import WorkshopWorkshopPreferences from './WorkshopWorkshopPreferences';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopPreferencesPanelProps {
  meeting: Meeting | null;
  preferences: MeetingMemberPreferences;
  profilePhone?: string;
  userEmail?: string;
  onSave: (updates: Partial<MeetingMemberPreferences>) => Promise<void>;
  onSavePhone: (phone: string) => Promise<void>;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
}

const WorkshopPreferencesPanel: React.FC<WorkshopPreferencesPanelProps> = ({
  meeting,
  preferences,
  profilePhone,
  userEmail,
  onSave,
  onSavePhone,
  expanded = false,
  onExpandedChange,
}) => {
  const subtitle = preferencesCardSubtitle(preferences, profilePhone);

  return (
    <WorkshopCollapsibleCard
      id="workshop-preferences"
      title="My preferences for this workshop"
      subtitle={subtitle}
      open={expanded}
      onOpenChange={onExpandedChange}
    >
      <p className={styles.prefSummaryHint}>
        Phone list, email list, and sponsor availability — only visible to workshop members.
      </p>
      <WorkshopWorkshopPreferences
        embedded
        meeting={meeting}
        preferences={preferences}
        profilePhone={profilePhone}
        userEmail={userEmail}
        onSave={onSave}
        onSavePhone={onSavePhone}
      />
    </WorkshopCollapsibleCard>
  );
};

export default WorkshopPreferencesPanel;
